export default __webpack_public_path__ + "static/g403-136e401722f6e2c8f0704057cd1b66d5.jpg";